<template>
    <v-container>
        <v-card class="mx-auto" flat>
            <v-row>
                <v-col>
                    <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
                      Publicación de Sentencias
                    </p>
                </v-col>
                <v-col class="mt-5" style="color:#1A237E; font-size: 17px !important;" align="right" >
                  <b> Num. de Visitas: {{ visitaCount }} </b>
                </v-col>
            </v-row>
            <v-divider class="mb-2"></v-divider>

            <v-row>
                <v-col align="right">
                    <v-btn
                      tile
                      small
                      color="#AF8936"
                      dark
                      to="/sentencias"
                    >
                        <v-icon left>
                            mdi-magnify
                        </v-icon>
                        Consultar Sentencias
                    </v-btn>
                </v-col>
            </v-row>

            <div class="parrafo mt-2">
                <p>El H. Supremo Tribunal de Justicia del Estado de Jalisco, en  Sesión Plenaria de fecha 09 de marzo del año 2021, aprobó la utilización del software denominado “Elida Judicial”  el cual fue creado por este Tribunal para la elaboración de testados y versiones públicas, apegado a los “Lineamientos Generales en Materia de Clasificación y Desclasificación de Información, así como para la elaboración de Versiones Públicas” emitidos por el Consejo Nacional del Sistema Nacional de Transparencia.</p>
                <p>Con dicho acuerdo debería dejarse de utilizar el programa Test-Data mismo que había sido aprobado en la Sesión Plenaria de fecha 26 de enero del año 2021; ambos softwares son herramientas que ayudan a los sujetos obligados en la elaboración de versiones públicas de las resoluciones y documentos generados que contienen información clasificada como confidencial o reservada.
                </p>
                <p>El software “Elida” cuenta con un clasificador de información que facilita a las personas que consultan las versiones públicas de las sentencias a identificarlas por materia (penal, civil, mercantil y familiar), acción y delito, lo cual contribuye de una manera íntegra con los principios rectores de la transparencia como son  certeza, eficacia, gratuidad, imparcialidad, independencia, interés general, legalidad, libre acceso, máxima publicidad, mínima formalidad, objetividad, presunción de existencia, profesionalismo, sencillez y celeridad y transparencia; además apoya a que cada día aumente el número de sentencias publicadas.
                <p>
                  Lo anterior con la finalidad cumplir con lo ordenado en la reforma del artículo 73 fracción II de la Ley General de Transparencia y Acceso a la Información Pública, así como al artículo 11 fracción X de la Ley de Transparencia y Acceso a la Información Pública del Estado de Jalisco y sus Municipios, que obligan a publicar las versiones públicas de las sentencias emitidas.
                </p>
                <p>
                  Actualmente “Elida Judicial” mediante la firma del Convenio General de Colaboración ha sido compartido por este Supremo Tribunal de Justicia del Estado de Jalisco, a nivel nacional e internacional con diferentes Instituciones Gubernamentales y Poderes Judiciales, entre los que podemos mencionar la Corte Nacional de Justicia de Ecuador;   el Instituto Nacional de Transparencia, Acceso a la Información Pública y Protección de Datos Personales (INAI); Instituto de Justicia Alternativa (IJA), la Escuela Judicial de Nayarit, Instituto de Transparencia del Estado de Nayarit; Tribunal de Justicia Alternativa del Estado de Jalisco; Tribunal Superior de Justicia y del Consejo de la Judicatura del Estado de Campeche; Instituto de Transparencia Acceso a la Información Pública y Protección de Datos Personales del Estado de Colima; Comisión Estatal de Garantía de Acceso a la Información Pública de San Luis Potosí y  con los  Órganos Garantes del Derecho de Acceso a la Información de  los Estado de Aguascalientes, Baja California Norte, Baja California Sur, Coahuila, Guerrero, Michoacán, Nayarit, Tlaxcala, Veracruz y Zacatecas.
                </p>
                <p>
                  Anteriormente, de igual forma el Pleno de este H. Supremo Tribunal de Justicia del Estado de Jalisco, con fecha 28 veintiocho de marzo del año 2014 dos mil catorce, determinó la publicación de las sentencias que hubieran causado estado, una vez que estuviera implementado el sistema electrónico para protección de datos personales.
                </p>
            </div>

            <v-row>
                <v-col>
                    <p class="text-center font-weight-bold" style="color:#AF8936">
                        Estadísticas de Sentencias Públicadas por Materia
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-card color="#F2F2F2">
                        <v-card-title style="color: #616161; font-size: 17px" class="mb-n5" >
                            SENTENCIAS MATERIA CIVIL
                        </v-card-title>
                        <v-card-title class="mb-n3" style="color: #AF8936; font-size: 27px">
                            {{ total_civiles.toLocaleString('es-MX') }}
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card color="#F2F2F2">
                        <v-card-title style="color: #616161; font-size: 17px" class="mb-n5" >
                            SENTENCIAS MATERIA PENAL
                        </v-card-title>
                        <v-card-title class="mb-n3" style="color: #AF8936; font-size: 27px">
                            {{ total_penales.toLocaleString('es-MX') }}
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card color="#F2F2F2">
                        <v-card-title style="color: #616161; font-size: 17px" class="mb-n5" >
                            TOTAL DE SENTENCIAS PUBLICADAS
                        </v-card-title>
                        <v-card-title class="mb-n3" style="color: #AF8936; font-size: 27px">
                            {{ total.toLocaleString('es-MX') }}
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-10" style="color:#1A237E; font-size: 20px !important;" align="center" >
                  <b> Num. de Visitas: {{ visitaCount }} </b>
              </v-col>
            </v-row>

            <!--<v-row class="mt-2">
                <v-col cols="6">
                    <ul>
                        <li v-for="sala in listSalas" class="mb-n3 pt-n8">
                            <v-card-subtitle class="mt-n5">{{sala.nombre}}</v-card-subtitle>
                        </li>
                    </ul>

                </v-col>
            </v-row>-->

            <!-- <div class="mt-8 parrafo"> -->
                <!-- <p>En relación a la publicación de los convenidos que registra el Instituto de Justicia Alternativa, es información que
                    no genera este Tribunal, más atendiendo al principio de máxima publicidad, se indica que en términos del artículo 3º.
                    De la Ley Orgánica del Poder Judicial del Estado de Jalisco, los integrantes del Poder Judicial son autónomos para
                    rendir la información que generen de acuerdo a sus atribuciones; de esa manera el Instituto de Justicia Alternativa,
                    es parte del Poder Judicial, como un órgano con autonomía técnica y administrativa, encargado de proporcionar el
                    servicio de justicia alternativa, a través de los medios alternos de resolución de conflictos, conforme lo establece
                    el artículo 22 de la Ley de Justicia Alternativa del Estado de Jalisco, en relación al 56 de la Constitución Política
                    del Estado de Jalisco.
                </p> -->
            <!-- </div> -->
        </v-card>
    </v-container>
</template>

<script>
    import axios from "axios";

    export default {
    data: () => ({
        //panel: [0, 1],
        //disabled: false,
        readonly: true,
        listSalas:[
          {id:1, nombre: 'Primera Sala Especializada en Materia Penal'},
          {id:1, nombre: 'Segunda Sala Especializada en Materia Penal'},
          {id:1, nombre: 'Tercera Sala Especializada en Materia Civil'}
        ],
        total_civiles: 0,
        total_penales: 0,
        total: 0,
        visitaCount: '',
        visita: {
          path: window.location.pathname,
          device: navigator.userAgent,
        },
    }),
    mounted(){
      this.getTotales();
      this.saveVisita();
      //this.getAddress();
      //this.Aamazon_trust_services();
      //
    },
    methods:{
      getTotales() {
        this.$store.dispatch("GET_TOTALES_POR_SALA",  { url: "/tocas/totales" } ).then(response => {
          this.total_penales = response.data.data.penales
          this.total_civiles = response.data.data.civiles
          this.total = this.total_penales + this.total_civiles
        })
        .catch(error => {
          console.log(error);
        });
      },
     Aamazon_trust_services() {
     this.$store.dispatch("Amazon_Trust_Services",  { url: "/amazon-trust-services" } ).then(response => {
     })
       .catch(error => {
           console.log(error);
       });
     },
     getCookie(cname) {
       let name = cname + "=";
       let decodedCookie = decodeURIComponent(document.cookie);
       let ca = decodedCookie.split(';');
       for(let i = 0; i <ca.length; i++) {
         let c = ca[i];
         while (c.charAt(0) == ' ') {
           c = c.substring(1);
         }
         if (c.indexOf(name) == 0) {
           return c.substring(name.length, c.length);
         }
       }
       return "";
     },
     saveVisita() {
      var visit = this.getCookie("visit");
    //   var options = {
    //   enableHighAccuracy: true,
    //   timeout: 6000,
    //   maximumAge: 0
    // };
    //   function success(position) {
    //     var coordenadas = position.coords;
    //
    //     console.log('Tu posición actual es:');
    //     console.log('Latitud : ' + coordenadas.latitude);
    //     console.log('Longitud: ' + coordenadas.longitude);
    //     console.log('Más o menos ' + coordenadas.accuracy + ' metros.');
    //   };
    //
    //   function error(error) {
    //     console.warn('ERROR(' + error.code + '): ' + error.message);
    //   };
    //
    //   navigator.geolocation.getCurrentPosition( success, error, options );
       if(!visit){
         document.cookie = "visit=true;max-age=86400";
         var data = this.visita
         } else {
           var data = {visita: false}
         }
         this.$store.dispatch("SAVE_VISITA", {
           url: "/visita",
           data : data
         })
         .then((response) => {
           this.visitaCount = response.data.data.visitas.toLocaleString()
         })
         .catch(() => {
           // Silencioso — la visita es un contador interno
         });
     },
//      getAddress (latitude, longitude) {
//     return new Promise(function (resolve, reject) {
//         var request = new XMLHttpRequest();
//         var latitude = 20.677326911053587;
//         var longitude = -103.34607530415592;
//
//         var method = 'GET';
//       //  var url = 'http://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&sensor=true';
//         var url = 'https://www.latlong.net/c/?lat=20.677326911053587&long=-103.34607530415592'
//         var async = true;
//
//         request.open(method, url, async);
//         request.onreadystatechange = function () {
//             if (request.readyState == 4) {
//                 if (request.status == 200) {
//                     var data = JSON.parse(request.responseText);
//                     var address = data.results[0];
//                     console.log(address);
//                 }
//                 else {
//                     reject(request.status);
//                 }
//             }
//         };
//         request.send();
//     });
// },

    }
  }
</script>

<style scoped>
    .parrafo {
        color: #000000;
        font-size: 15px;
        text-align: justify;
        font-family: inherit;
        font-weight: normal;
        line-height: 1.6;
        margin-bottom: 17px;
    }
</style>
